export enum ProductLocation {
  'Maryville' = 'Maryville',
  'Greenback' = 'Greenback',
}
